module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-500.dc6d2760.woff2";